/* ==========================================================================
   Dogs Supreme — Shared Utilities
   Loaded globally via theme.liquid. Provides DS.formatMoney + DS.trackEvent.
   ========================================================================== */

window.DS = window.DS || {};

/**
 * Format price in EUR (German locale).
 * Handles both cents (integer) and decimal strings from Shopify API.
 * Replaces 5 separate implementations across the theme.
 *
 * @param {number|string} cents - Price in cents or decimal string (e.g. "33.95")
 * @returns {string} Formatted price like "33,95 €" or "" if empty
 */
DS.formatMoney = function(cents) {
  if (!cents && cents !== 0) return '';
  if (typeof cents === 'string' && cents.indexOf('.') !== -1)
    cents = Math.round(parseFloat(cents) * 100);
  if (typeof cents === 'string') cents = parseInt(cents, 10);
  return (cents / 100).toFixed(2).replace('.', ',') + '\u00A0\u20AC';
};

/**
 * Push GA4 event to dataLayer.
 * Standardizes gtag vs dataLayer inconsistency across sections.
 *
 * @param {string} event - Event name (e.g. "add_to_cart")
 * @param {Object} params - Event parameters
 */
DS.trackEvent = function(event, params) {
  if (window.dataLayer) {
    var payload = { event: event };
    if (params) {
      for (var key in params) {
        if (params.hasOwnProperty(key)) payload[key] = params[key];
      }
    }
    window.dataLayer.push(payload);
  }
};
